import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M26.352 9.28a11 11 0 0 0-10.617-7.277C9.772 2.143 4.967 7.095 5 13.062a10.98 10.98 0 0 0 4.222 8.603c.49.38.776.965.778 1.584V24l.005.15A2 2 0 0 0 12 26h8l.15-.005A2 2 0 0 0 22 24v-.753l.008-.168c.05-.557.332-1.075.781-1.423A11 11 0 0 0 26.352 9.28M22 29a1 1 0 0 0-1-1H11l-.117.007A1 1 0 0 0 11 30h10l.117-.007A1 1 0 0 0 22 29M16.059 4l-.277.003C10.91 4.117 6.973 8.174 7 13.052a8.98 8.98 0 0 0 3.215 6.844l.415.338a4.01 4.01 0 0 1 1.363 2.781l.007.231V24h8v-.759a4.04 4.04 0 0 1 1.38-3.016l.404-.33A9 9 0 0 0 16.059 4m1.124 2.112-.116-.013a1 1 0 0 0-.22 1.985 4.99 4.99 0 0 1 4.083 4.077 1 1 0 1 0 1.971-.337 6.99 6.99 0 0 0-5.718-5.712"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconGiveFeedback = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconGiveFeedback);
export default Memo;
